import React, {
  useContext, useEffect, useState,
} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import {
  Button,
  Card, Dropdown, ListGroup, Row,
} from 'react-bootstrap';
import { faBell, faGear, faRedo } from '@fortawesome/free-solid-svg-icons';
import CardHeader from '../../common/CardHeader';
import Notification from '../../notification/Notification';
import { isIterableArray } from '../../helpers/utils';
import { CiatAppContext } from '../../../../providers';
import IconButton from '../../common/IconButton';
import { EmailContext } from '../../context/Context';
import EmailProvider from '../../email/EmailProvider';
import useReadMessage from '../../hooks/useReadMessage';

function NotificationDropdownElement() {
  const { emails, fetchEmails } = useContext(EmailContext);
  const [newNotifications, setNewNotifications] = useState([]);
  const [earlierNotifications, setEarlierNotifications] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isAllRead, setIsAllRead] = useState(false);
  const { currentUser } = useContext(CiatAppContext);
  const { changeRead } = useReadMessage();

  useEffect(() => {
    if (emails.length > 0) {
      setNewNotifications(emails.filter((obj) => obj.read === false));
      setEarlierNotifications(emails.filter((obj) => obj.read === true));
    }
  }, [emails, setNewNotifications, setEarlierNotifications]);

  // Handler
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setIsAllRead(newNotifications.length === 0 || emails.length === 0);
  }, [emails, newNotifications]);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      // eslint-disable-next-line no-unused-expressions
      window.innerWidth < 1500 && setIsOpen(false);
    });
  }, []);

  const handleActionButtonClick = () => {
    newNotifications.map((email) => changeRead(email.id));
    fetchEmails();
  };

  return (
    <Dropdown navbar as="li" show={isOpen} onToggle={handleToggle}>
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="px-0 nav-link"
      >
        <FontAwesomeIcon icon={faBell} transform="shrink-6" className="fs-4" />
        {!isAllRead && <span className="notification-count">{newNotifications.length}</span>}
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-menu-card dropdown-menu-end dropdown-caret dropdown-caret-bg">
        <Card
          className="dropdown-menu-notification dropdown-menu-end shadow-none"
          style={{ maxWidth: '20rem' }}
        >
          <CardHeader
            className="card-header"
            title=""
            titleTag="h6"
            light={false}
            endEl={(
              <>
                { !isAllRead && (
                <Link
                  className="card-link fw-normal"
                  to="#!"
                  onClick={() => handleActionButtonClick()}
                >
                  Помітити всі як прочитані
                </Link>
                )}
                <>
                  <IconButton
                    variant="falcon-default"
                    size="sm"
                    className="ms-sm-1"
                    icon={faRedo}
                    onClick={() => { fetchEmails(); }}
                  />
                  <FontAwesomeIcon icon="redo" />
                </>
                {currentUser.is_superuser && (
                <Button
                  variant="link"
                  size="sm"
                  className="rounded-circle px-2 py-1 bg-light"
                  as={Link}
                  to="/email/inbox"
                  state={{ openSettings: true }}
                  onClick={handleToggle}
                >
                  <FontAwesomeIcon icon={faGear} />
                </Button>
                )}
              </>
            )}
          />
          { (emails.length > 0) ? (
            <ListGroup
              variant="flush"
              className="fw-normal fs--1 scrollbar"
              style={{ maxHeight: '19rem' }}
            >
              <div className="list-group-title">Нові повідомлення</div>
              {' '}
              {isIterableArray(newNotifications)
                && newNotifications.map((notification) => (
                  <ListGroup.Item key={notification.id} onClick={handleToggle}>
                    <Notification {...notification} flush />
                  </ListGroup.Item>
                ))}
              <div className="list-group-title">Прочитані</div>
              {isIterableArray(earlierNotifications)
                && earlierNotifications.map((notification) => (
                  <ListGroup.Item key={notification.id} onClick={handleToggle}>
                    <Notification {...notification} flush />
                  </ListGroup.Item>
                ))}
            </ListGroup>
          ) : (
            <div className="text-center">Повідомлень поки немає</div>
          )}
          { (emails.length > 0) && (
          <Row
            className="card-footer text-center border-top"
            onClick={handleToggle}
          >
            <Link className="card-link d-block" to="/email/inbox">
              Показати всі
            </Link>
          </Row>
          )}
        </Card>
      </Dropdown.Menu>
    </Dropdown>
  );
}

function NotificationDropdown() {
  return (
    <EmailProvider>
      <NotificationDropdownElement />
    </EmailProvider>
  );
}

export default NotificationDropdown;
